// Centralized API and WebSocket configuration for AGENT_19-10
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://agentapi.dynamicsoftlink.com/api';
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'https://agentapi.dynamicsoftlink.com';
